import { render, staticRenderFns } from "./UnitManagement.vue?vue&type=template&id=5ea414c4&scoped=true"
import script from "./UnitManagement.vue?vue&type=script&lang=js"
export * from "./UnitManagement.vue?vue&type=script&lang=js"
import style0 from "./UnitManagement.vue?vue&type=style&index=0&id=5ea414c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea414c4",
  null
  
)

export default component.exports